import EnvelopeIcon from "@Icons/EnvelopeIcon";
import PhoneIcon from "@Icons/PhoneIcon";
import WhatsAppIcon from "@Icons/WhatsAppIcon";
import config from "config/index";
import themeVariables from "@Theme/exportColor.module.scss";
import {
  ABOUT_URL,
  AMBASSADOR_URL,
  AMBERPLUS_URL,
  BLOG_URL,
  CAREERS_URL,
  EMAIL_1,
  EXAMS_URL,
  GROUP_BOOKINGS_URL,
  HOW_IT_WORKS_URL,
  LEADS_LIST,
  MEDIA_MENTION_URL,
  NEWSROOM_URL,
  PARTNER_WITH_AMBER_URL,
  PHONE_1,
  PHONE_2,
  PHONE_3,
  PHONE_4,
  PODCAST_URL,
  REFER_URL,
  SCHOLARSHIP_URL,
  UNIVERSITIES_URL,
  WHATSAPP_URL,
} from "constants/configConstants";
import WechatOutline from "@Icons/WechatOutline";
import { HK_WEIXIN_DWEB } from "helpers/getWeComUrlBasedOnSource";

// import { WECHAT_CHAT_URL } from "constants/index";

export const TRUSTPILOT_REVIEWS_COUNT = {
  ROUNDED: 5000,
  ABSOLUTE: 4127,
};

export const footerListLeft = [
  { name: "home.footer.suboptions.about", link: ABOUT_URL, gaKey: "About", localize: true },
  {
    name: "home.footer.suboptions.howitworks",
    link: HOW_IT_WORKS_URL,
    gaKey: "How it works",
    localize: true,
  },
  {
    name: "home.footer.suboptions.referafriend",
    link: REFER_URL,
    gaKey: "Refer a Friend",
    localize: true,
  },
  {
    name: "home.footer.suboptions.groupbookings",
    link: GROUP_BOOKINGS_URL,
    extraText: "home.footer.suboptions.new",
    gaKey: "Group Bookings",
  },
  {
    name: "home.footer.suboptions.listwithus",
    link: LEADS_LIST,
    extraText: "home.footer.suboptions.new",
    gaKey: "List with us",
    localize: true,
  },
  {
    name: "home.footer.suboptions.partnerwithus",
    extraText: "home.footer.suboptions.new",
    link: PARTNER_WITH_AMBER_URL,
    gaKey: "Partner with us",
  },
  {
    name: "home.footer.suboptions.universities",
    extraText: "home.footer.suboptions.new",
    link: UNIVERSITIES_URL,
    gaKey: "Universities",
  },
  {
    name: "home.footer.suboptions.careers",
    extraText: "home.footer.suboptions.wearehiring",
    link: CAREERS_URL,
    gaKey: "Careers",
    localize: true,
  },
];

export const footerListLeftChina = [
  { name: "home.footer.suboptions.about", link: ABOUT_URL, gaKey: "About" },
  {
    name: "home.footer.suboptions.howitworks",
    link: HOW_IT_WORKS_URL,
    gaKey: "How it works",
  },
  { name: "home.footer.suboptions.referafriend", link: REFER_URL, gaKey: "Refer a Friend" },
  {
    name: "home.footer.suboptions.groupbookings",
    link: GROUP_BOOKINGS_URL,
    extraText: "home.footer.suboptions.new",
    gaKey: "Group Bookings",
  },
  {
    name: "home.footer.suboptions.listwithus",
    link: LEADS_LIST,
    extraText: "home.footer.suboptions.new",
    gaKey: "List with us",
  },
  {
    name: "home.footer.suboptions.universities",
    extraText: "home.footer.suboptions.new",
    link: UNIVERSITIES_URL,
    gaKey: "Universities",
  },
];

export const footerListRight = [
  { name: "home.footer.suboptions.blog", link: BLOG_URL, gaKey: "Blog" },
  { name: "home.footer.suboptions.podcast", link: PODCAST_URL, gaKey: "Podcast" },
  { name: "home.footer.suboptions.newsroom", link: NEWSROOM_URL, gaKey: "Newsroom" },
  { name: "home.footer.suboptions.amberplus", link: AMBERPLUS_URL, gaKey: "Amber Plus" },
  {
    name: "home.footer.suboptions.mediamention",
    link: MEDIA_MENTION_URL,
    gaKey: "Media Mention",
    localize: true,
  },
  {
    name: "home.footer.suboptions.ambassador",
    link: AMBASSADOR_URL,
    gaKey: "Ambassador",
    localize: true,
  },
  {
    name: "home.footer.suboptions.scholarships",
    link: SCHOLARSHIP_URL,
    extraText: "home.footer.suboptions.applynow",
    gaKey: "Scholarships",
    localize: true,
  },
  {
    name: "home.footer.suboptions.exams",
    link: EXAMS_URL,
    extraText: "home.footer.suboptions.new",
    gaKey: "Exams",
  },
];

export const footerListRightChina = [
  { name: "home.footer.suboptions.ambassador", link: AMBASSADOR_URL, gaKey: "Ambassador" },
  {
    name: "home.footer.suboptions.scholarships",
    link: SCHOLARSHIP_URL,
    extraText: "home.footer.suboptions.applynow",
    gaKey: "Scholarships",
  },
];

export const contactDetails = [
  {
    icon: EnvelopeIcon({ fill: themeVariables.primary5 }),
    label: EMAIL_1,
    link: `mailto:${EMAIL_1}`,
    isVisibleForChina: true,
  },
  {
    icon: config.IS_CHINA_APP
      ? WechatOutline({ height: "16", width: "16", fill: themeVariables.primary5 })
      : WhatsAppIcon({ fill: "#25D366" }),
    label: config.IS_CHINA_APP ? `WeChat` : `WhatsApp`,
    // eslint-disable-next-line no-nested-ternary
    link: config.IS_CHINA_APP ? HK_WEIXIN_DWEB : WHATSAPP_URL,
    isVisibleForChina: true,
  },
];

export const addCountryWiseContactInfo = (countryCode: string) => {
  const UK_PHONE = {
    icon: PhoneIcon({ fill: themeVariables.primary5 }),
    label: `${PHONE_1.country_code} ${PHONE_1.number}`,
    link: `tel: ${PHONE_1.full_number}`,
    isVisibleForChina: false,
  };

  const AU_PHONE = {
    icon: PhoneIcon({ fill: themeVariables.primary5 }),
    label: `${PHONE_4.country_code} ${PHONE_4.number}`,
    link: `tel: ${PHONE_4.full_number}`,
    isVisibleForChina: false,
  };

  const US_PHONE = {
    icon: PhoneIcon({ fill: themeVariables.primary5 }),
    label: `${PHONE_3.country_code} ${PHONE_3.number}`,
    link: `tel: ${PHONE_3.full_number}`,
    isVisibleForChina: false,
  };

  const INDIA_PHONE = {
    icon: PhoneIcon({ fill: themeVariables.primary5 }),
    label: `${PHONE_2.country_code} ${PHONE_2.number}`,
    link: `tel: ${PHONE_2.full_number}`,
    isVisibleForChina: false,
  };

  let selectedPhone = {};

  switch (countryCode) {
    case "AU":
      selectedPhone = AU_PHONE;
      break;
    case "US":
      selectedPhone = US_PHONE;
      break;
    case "IN":
      selectedPhone = INDIA_PHONE;
      break;
    default:
      selectedPhone = UK_PHONE;
      break;
  }
  return [...contactDetails, selectedPhone];
};
